import { PatchDataApi, PatchDataPostRequest } from '@api/twin/PatchDataApi';
import { Twin } from '@api/twin/TwinApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { usePluginTranslation } from '@translation';

export const usePatchData = (twin: Twin) => {
  const queryKeys = ['PatchData'];
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;
  const queryClient = useQueryClient();
  const { t } = usePluginTranslation();

  const { mutate: submitPatchData, isPending } = useMutation({
    mutationFn: async (t: { patchDataRequest: PatchDataPostRequest }) => {
      await PatchDataApi(client).postPatchData(twin.projectId, twin.type, t.patchDataRequest);
    },
    onMutate: () => {
      return viewer.notificationCenter.pushNotification({
        type: 'Patch Data',
        status: 'pending',
        message: t('patch_data_plugin.form.submit.loading.text'),
        title: t('patch_data_plugin.form.submit.notification_title'),
        displayed: true,
      });
    },
    onSuccess: (_data, _variables, notificationId) => {
      viewer.notificationCenter.pushNotification({
        type: 'Patch Data',
        status: 'success',
        message: t('patch_data_plugin.form.submit.notification_title'),
        title: t('patch_data_plugin.form.submit.notification_title'),
        displayed: true,
      }, notificationId);

      return queryClient.invalidateQueries({
        queryKey: [...queryKeys, twin.projectId],
      });
    },
    onError: (_error, _variables, notificationId) => {
      viewer.notificationCenter.pushNotification({
        type: 'Patch Data',
        status: 'error',
        message: t('patch_data_plugin.form.submit.error.text'),
        title: t('patch_data_plugin.form.submit.notification_title'),
        displayed: true,
      }, notificationId);
    },
  });

  return {
    submitPatchData,
    isPending,
  };
};
